import React from "react";
import { View, Text, Image, StyleSheet, TouchableOpacity } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useTheme } from "../../../context/ThemeContext";
import { ProductRating } from "./ProductRating";

export const ProductCard = ({ product, onPress }) => {
	const theme = useTheme();
	const styles = useStyles();

	return (
		<TouchableOpacity style={styles.card} activeOpacity={0.8} onPress={() => onPress(product)}>
			<View style={styles.imageContainer}>
				{product.images && product.images.length > 0 ? (
					<Image source={{ uri: product.images[0] }} style={styles.image} resizeMode="cover" />
				) : (
					<View style={styles.noImage}>
						<Ionicons name="image-outline" size={24} color={theme.colors.textSecondary} />
					</View>
				)}
				{product.onSale && (
					<View style={styles.saleTag}>
						<Text style={styles.saleText}>SALE</Text>
					</View>
				)}
				{!product.inStock && (
					<View style={styles.outOfStockOverlay}>
						<Text style={styles.outOfStockText}>OUT OF STOCK</Text>
					</View>
				)}
			</View>

			<View style={styles.content}>
				<Text style={styles.title} numberOfLines={1}>
					{product.title}
				</Text>

				<View style={styles.ratingContainer}>
					<ProductRating rating={product.rating} size={14} />
					<Text style={styles.reviewCount}>({product.reviewCount})</Text>
				</View>

				<View style={styles.priceContainer}>
					{product.onSale ? (
						<>
							<Text style={styles.salePrice}>${product.salePrice.toFixed(2)}</Text>
							<Text style={styles.originalPrice}>${product.price.toFixed(2)}</Text>
						</>
					) : (
						<Text style={styles.price}>${product.price.toFixed(2)}</Text>
					)}
				</View>

				{product.tags && product.tags.includes("featured") && (
					<View style={styles.featuredTag}>
						<Ionicons name="star" size={12} color={theme.colors.warning} />
						<Text style={styles.featuredText}>Featured</Text>
					</View>
				)}
			</View>
		</TouchableOpacity>
	);
};

const useStyles = () => {
	const theme = useTheme();

	return StyleSheet.create({
		card: {
			width: "48%",
			backgroundColor: theme.colors.systemBackground.primary,
			borderRadius: theme.borderRadius.md,
			overflow: "hidden",
			marginBottom: theme.spacing.md,
			shadowColor: "#000",
			shadowOffset: { width: 0, height: 2 },
			shadowOpacity: 0.1,
			shadowRadius: 4,
			elevation: 2,
		},
		imageContainer: {
			position: "relative",
			height: 150,
			width: "100%",
		},
		image: {
			width: "100%",
			height: "100%",
		},
		noImage: {
			width: "100%",
			height: "100%",
			backgroundColor: theme.colors.systemBackground.secondary,
			justifyContent: "center",
			alignItems: "center",
		},
		saleTag: {
			position: "absolute",
			top: theme.spacing.xs,
			right: theme.spacing.xs,
			backgroundColor: theme.colors.error,
			paddingHorizontal: theme.spacing.xs,
			paddingVertical: 2,
			borderRadius: theme.borderRadius.sm,
		},
		saleText: {
			color: theme.colors.systemBackground.primary,
			fontSize: 10,
			fontWeight: "bold",
		},
		outOfStockOverlay: {
			position: "absolute",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: "rgba(0, 0, 0, 0.6)",
			justifyContent: "center",
			alignItems: "center",
		},
		outOfStockText: {
			color: "#fff",
			fontWeight: "bold",
			fontSize: 12,
			letterSpacing: 0.5,
		},
		content: {
			padding: theme.spacing.sm,
		},
		title: {
			...theme.typography.subhead,
			color: theme.colors.text,
			fontWeight: "600",
			marginBottom: theme.spacing.xs,
		},
		ratingContainer: {
			flexDirection: "row",
			alignItems: "center",
			marginBottom: theme.spacing.xs,
		},
		reviewCount: {
			...theme.typography.caption,
			color: theme.colors.textSecondary,
			marginLeft: 4,
		},
		priceContainer: {
			flexDirection: "row",
			alignItems: "center",
		},
		price: {
			...theme.typography.subhead,
			color: theme.colors.text,
			fontWeight: "600",
		},
		salePrice: {
			...theme.typography.subhead,
			color: theme.colors.error,
			fontWeight: "600",
			marginRight: theme.spacing.xs,
		},
		originalPrice: {
			...theme.typography.caption,
			color: theme.colors.textSecondary,
			textDecorationLine: "line-through",
		},
		featuredTag: {
			flexDirection: "row",
			alignItems: "center",
			marginTop: theme.spacing.xs,
		},
		featuredText: {
			...theme.typography.caption,
			color: theme.colors.warning,
			marginLeft: 2,
			fontWeight: "500",
		},
	});
};
